import React from 'react'

import Social from '../../companyProfile/components/Social'
import { CMS } from '../../config'

const YfSocial = () => (
  <Social info={{ social_links: CMS.YFSOCIAL }} />
)

export default YfSocial
